export default __webpack_public_path__ + "static/main-stripe-d56f9c8d91764b8b829d863fecf196be.png";